<template>
  <v-form id="inn-form" ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
    <v-card id="inn-card" flat tile class="pa-4">
      <v-row justify="center" align="center" no-gutters class="fill-height">
        <v-card-title>
          <div class="text-center">
            <h5 class="headline font-weight-bold">Вход в систему</h5>
            <p id="subtitle" class="subtitle-1 grey--text text--darken-2">Введите инн</p>
          </div>
        </v-card-title>
        <v-card-text>
          <v-text-field
            autofocus
            class="mb-4"
            :rules="innOrganisationRules"
            outlined
            v-model.trim="innOrganisation"
            v-mask="mask"
            counter="14"
            ref="innOrganisation"
            name="innOrganisation"
            label="ИНН организации"
            autocomplete="off"
            clearable
            validate-on-blur
            :loading="loadingOrganisationInn"
            :messages="organisationName"
          />
          <v-text-field
            :rules="innPersonalRules"
            outlined
            v-model.trim="innPersonal"
            v-mask="mask"
            counter="14"
            ref="innPersonal"
            name="innPersonal"
            label="персональный ПИН"
            autocomplete="off"
            clearable
            validate-on-blur
            :loading="loadingPersonalInn"
            :messages="personalName"
          />
        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn
            name="innBtn"
            :loading="loadingCheckInn"
            :disabled="loadingCheckInn"
            large
            rounded
            type="submit"
            color="primary"
            class="px-8"
          >
            <span class="pl-2">Далее</span>
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-row>
    </v-card>
  </v-form>
</template>

<script>
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex'
export default {
  name: 'Inn',
  directives: { mask },
  data: () => ({
    valid: true,
    mask: '##############',
    innOrganisation: '',
    innPersonal: '',
    innOrganisationRules: [
      v => !!v || 'Необходимо ввести ИНН организации',
      v => (v && v.length > 13) || 'ИНН организации должен быть равен 14 цифрам'
    ],
    innPersonalRules: [
      v => !!v || 'Необходимо ввести персональный ПИН',
      v => (v && v.length > 13) || 'персональный ПИН должен быть равен 14 цифрам'
    ]
  }),
  watch: {
    innOrganisation(val) {
      if (val && val.length === 14) {
        this.$store.dispatch('GET_NAME', { inn: this.innOrganisation, trigger: 'organisation' })
      }
      this.$store.commit('CLEAR_NAMES', { type: 'organisation' })
    },
    innPersonal(val) {
      if (val && val.length === 14) {
        this.$store.dispatch('GET_NAME', { inn: this.innPersonal, trigger: 'personal' })
      }
      this.$store.commit('CLEAR_NAMES', { type: 'personal' })
    }
  },
  computed: {
    ...mapState({
      organisationName: state => state.auth.response.organisationName,
      personalName: state => state.auth.response.personalName,
      loadingOrganisationInn: state => state.auth.loading.innOrganisation,
      loadingPersonalInn: state => state.auth.loading.innPersonal,
      loadingCheckInn: state => state.auth.loading.checkInn
    })
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('CHECK_INN', {
          innOrganisation: this.innOrganisation,
          innEmployee: this.innPersonal
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#inn-card {
  height: 450px;
  border-radius: 8px;
}
</style>
